import { useCallback } from 'react';
import { atom, useAtomValue, useSetAtom } from 'jotai';
import { SelectionChangedEvent } from 'ag-grid-community';
import { CompanyMappingVM } from '../../../schemas/CompanyMappings.schema';
import { mappingsGridApiAtom } from './CompanyMappingsState';

export const selectedMappings = atom<CompanyMappingVM[]>([]);

export function useMappingsRowSelection() {
  const gridApi = useAtomValue(mappingsGridApiAtom);
  const setSelected = useSetAtom(selectedMappings);

  const deselectAll = useCallback(() => {
    if (gridApi) {
      gridApi?.deselectAll();
      setSelected([]);
    }
  }, [gridApi, setSelected]);

  const onSelectionChanged = useCallback(
    (e: SelectionChangedEvent) => {
      const selectedRows = e.api.getSelectedRows();
      setSelected(selectedRows);
    },
    [setSelected]
  );

  return { deselectAll, onSelectionChanged };
}
